export default "__VITE_ASSET__BgmIfmHz__"